import type { FunctionComponent } from 'react';
import { Panel as BSPanel } from 'react-bootstrap';

type PanelProps = {
  /**
   * @deprecated Avoid using className to apply custom style.
   */
  className?: string;
};

/**
 * Wrapper around Bootstap Panel component.
 *
 * @param {PanelProps} props - Panel props
 * @param {React.ReactNode} props.children - Panel contents.
 * @param {string} [props.className] - custom className (note: deprecated)
 */
const Panel: FunctionComponent<PanelProps> = ({ children, className }) => (
  <BSPanel className={className}>
    <BSPanel.Body>
      {children}
    </BSPanel.Body>
  </BSPanel>
);

export default Panel;
